import { Component, Inject, OnInit, Optional } from '@angular/core';
import {
  MatDialogRef as MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-info-popup-dialog',
  templateUrl: './info-popup-dialog.component.html',
  styleUrls: ['./info-popup-dialog.component.scss'],
  standalone: false
})
export class InfoPopupDialogComponent implements OnInit {
  navigationSubs: Subscription;
  public isLarge: boolean;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private router: Router,
    public dialogRef: MatDialogRef<InfoPopupDialogComponent>
  ) {
    this.navigationSubs = this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.dialogRef.close();
      }
    });
  }

  close() {
    this.dialogRef.close();
  }

  ngOnInit(): void {
    this.isLarge = this.data.isLarge
  }

  ngOnDestroy() {
    this.navigationSubs.unsubscribe();
  }
}
